__webpack_require__.j = "global.min";